<label class="common-ui-switch" id="{{id}}">
  <input (change)="onToggle()" [(ngModel)]="checked" [disabled]="readonly"
         id="input{{id}}"
         type="checkbox">
  <span class="common-ui-slider common-ui-round"></span>
</label>
